import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';

/* reducers from features/ */
import adminReducer from 'src/ui/features/Admin/state/adminReducer';
import preregisterApplicantsReducer from 'src/ui/features/PreregisterApplicants/state/preregisterApplicantsReducer';
import dashboardReducer from 'src/ui/features/Dashboard/state/dashboardReducer';
import maintenanceReducer from 'src/ui/features/Maintenance/state/maintenanceReducer';
import documentsReducer from 'src/ui/features/Documents/state/documentsReducer';
import consentReducer from 'src/ui/features/Consent/state/consentReducer';
import usersReducer from 'src/ui/features/Users/state/usersReducer';
import engagementsReducer from 'src/ui/features/Engagements/state/engagementsReducer';
import idValidatorReducer from 'src/ui/features/IdValidator/state/idValidatorReducer';
import lobbyMessageReducer from 'src/ui/features/LobbyMessage/state/lobbyMessageReducer';
import loginReducer from 'src/ui/features/Login/state/loginReducer';
import languageReducer from 'src/ui/features/Login/state/languageReducer';
import messagingReducer from 'src/ui/features/Messaging/state/messagingReducer';
import casesReducer from 'src/ui/features/Cases/state/casesReducer';
import caseUploadReducer from 'src/ui/features/CaseUpload/state/caseUploadReducer';
import proformaUploadReducer from 'src/ui/features/ProformaUpload/state/proformaUploadReducer';
import casesFilterReducer from 'src/ui/features/Cases/state/casesFilterReducer';
import caseUploadFilterReducer from 'src/ui/features/CaseUpload/state/caseUploadFilterReducer';
import proformaUploadFilterReducer from 'src/ui/features/ProformaUpload/state/proformaUploadFilterReducer';
import serviceInitReducer from 'src/ui/features/ServiceInit/state/serviceInitReducer';
import utilsReducer from 'src/utils/utilsReducer.js';
import questionnaireReducer from 'src/ui/features/Questionnaire/state/questionnaireReducer';
import chatReducer from 'src/ui/features/Chat/state/chatReducer';
import appUpdateReducer from 'src/ui/features/AppUpdate/state/appUpdateReducer';
import logsFilterReducer from 'src/ui/features/PreregisterApplicants/state/logsFilterReducer';
import moveApplicantFilterReducer from 'src/ui/features/PreregisterApplicants/state/moveApplicantFilterReducer';
import moveApplicantReducer from 'src/ui/features/PreregisterApplicants/state/moveApplicantReducer';
import paywallReducer from 'src/ui/features/Paywall/state/paywallReducer';

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  preregister:preregisterApplicantsReducer,
  documents: documentsReducer,
  consent: consentReducer,
  users: usersReducer,
  engagements: engagementsReducer,
  login: loginReducer,
  language: languageReducer,
  maintenance: maintenanceReducer,
  messaging: messagingReducer,
  cases: casesReducer,
  caseUpload: caseUploadReducer,
  proformaUpload: proformaUploadReducer,
  casesFilter: casesFilterReducer,
  logsFilter: logsFilterReducer,
  moveApplicantFilter: moveApplicantFilterReducer,
  moveApplicant: moveApplicantReducer,
  caseUploadFilter: caseUploadFilterReducer,
  idValidator: idValidatorReducer,
  proformaUploadFilter: proformaUploadFilterReducer,
  admin: adminReducer,
  serviceInit: serviceInitReducer,
  chat: chatReducer,
  lobbyMessage:lobbyMessageReducer,
  paywallRequest: paywallReducer,
  browser: createResponsiveStateReducer({
    extraSmall: 480,
    small: 600,
    medium: 960,
    large: 1280,
    extraLarge: 1920,
  }),
  utils: utilsReducer,
  questionnaire: questionnaireReducer,
  appUpdate: appUpdateReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/rootReducer.js